import modalConstants    from './modal.constants';
import modalInitialState from './modal.state';

function modalReducer(state = modalInitialState, action) {
  switch (action.type) {
    case modalConstants.SHOW_MODAL:
      state = {
        className: action.className || modalInitialState.className,
        left:      action.left || modalInitialState.left,
        open:      true,
        body:      action.body || modalInitialState.body,
        large:     action.large || modalInitialState.large,
        title:     action.title || modalInitialState.title,
        top:       action.top || modalInitialState.top,
      };
      break;

    case modalConstants.HIDE_MODAL:
      state = { ...modalInitialState };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default modalReducer;